import { fetchActivities } from '../services/ActivityService';
import { fetchEvents } from '../services/EventService';
import queryKeys from './queryKeys';
import { captureQueryProjection } from './queryProjectionRevision';

export const DISCOVER_STALE_MS = 60_000;
const normalizeArray = (data) => Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
const abortRetired = () => Object.assign(new Error('Discover request retired'), { name: 'AbortError' });

// Navigation and the destination capture the same ownership and credential.
// A late request may neither publish data nor revoke a newer owner's cache.
export const guardedDiscoverLoader = (queryKey, { queryClient, isCurrent = () => true } = {}, load) => async ({ signal }) => {
  const projectionCurrent = queryClient ? captureQueryProjection(queryClient, queryKey) : () => true;
  const current = () => !signal?.aborted && isCurrent() && projectionCurrent();
  if (!current()) throw abortRetired();
  try {
    const result = await load({ signal });
    if (!current()) throw abortRetired();
    return result;
  } catch (error) {
    if (!current()) throw abortRetired();
    throw error;
  }
};

export const discoverActivitiesQuery = (scope, options = {}) => {
  const queryKey = queryKeys.discover.activities(scope);
  return {
    queryKey,
    staleTime: DISCOVER_STALE_MS,
    queryFn: guardedDiscoverLoader(queryKey, options, ({ signal }) => fetchActivities({
      signal, token: options.token, useCache: false, returnJson: true,
    }).then(normalizeArray)),
  };
};
export const discoverEventsQuery = (scope, options = {}) => {
  const queryKey = queryKeys.discover.events(options.calendarScope ? {...scope, calendar: options.calendarScope.key} : scope);
  return {
    queryKey,
    staleTime: DISCOVER_STALE_MS,
    queryFn: guardedDiscoverLoader(queryKey, options, ({ signal }) => fetchEvents({
      signal, token: options.token, forceFresh: true,
      ...(options.calendarScope ? {params: options.calendarScope.query, calendarScope: options.calendarScope} : {}),
    })),
  };
};
